// Maps known agent IDs to advisor-facing field labels used in step messages.
// When new data-agent-id values are added to the UI, register their friendly
// label here so step entries read naturally.

const AGENT_ID_LABELS: Record<string, string> = {
  'new-plan-button': 'the new plan form',
  'plan-select': 'plan selector',
  'plan-name-input': 'plan name',
  'plan-start-term-select': 'start term',
  'plan-num-terms-input': 'number of terms',
  'create-plan-submit': 'plan'
}

// Agent IDs whose click opens something rather than submitting it, so the step
// reads "Opening ..." instead of "Submitting ...". Mostly dropdown menus.
export const DROPDOWN_AGENT_IDS = new Set([
  'new-plan-button',
  'plan-select',
  'plan-start-term-select'
])

export default function humanLabel(agentId: string): string {
  if (AGENT_ID_LABELS[agentId]) return AGENT_ID_LABELS[agentId]
  // Fallback: strip trailing technical suffixes and replace hyphens with spaces.
  return agentId.replace(/-(input|select|submit|button|field)$/, '').replace(/-/g, ' ')
}
